import { Component, Input, Output, EventEmitter, ChangeDetectionStrategy, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { User } from 'src/app/shared/model/user';
import { FileService } from 'src/app/shared/service/file.service';

@Component({
  selector: 'app-incoming-call-modal',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './incoming-call-modal.component.html',
  styleUrls: ['./incoming-call-modal.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IncomingCallModalComponent {
  fileService = inject(FileService);

  @Input() caller: User | null = null;
  @Input() isVisible = false;
  @Input() isAccepting = false;
  @Input() isDeclining = false;
  @Input() mode: 'incoming' | 'outgoing' | 'active' = 'incoming';
  @Input() elapsed = '00:00';

  @Output() accept = new EventEmitter<number>();
  @Output() decline = new EventEmitter<number>();
  @Output() cancel = new EventEmitter<void>();
  @Output() end = new EventEmitter<void>();


  onAccept(): void {
    if (this.caller?.id) {
      this.accept.emit(this.caller.id);
    }
  }

  onDecline(): void {
    if (this.caller?.id) {
      this.decline.emit(this.caller.id);
    }
  }

  onCancel(): void {
    this.cancel.emit();
  }

  onEnd(): void {
    this.end.emit();
  }

}
